__turbopack_context__.v({
  "badgeStyles": "onAirItem-module-scss-module__YVbyfa__badgeStyles",
  "contentWrapper": "onAirItem-module-scss-module__YVbyfa__contentWrapper",
  "imageWrapper": "onAirItem-module-scss-module__YVbyfa__imageWrapper",
  "mainWrapper": "onAirItem-module-scss-module__YVbyfa__mainWrapper",
  "metaDataWrapper": "onAirItem-module-scss-module__YVbyfa__metaDataWrapper",
  "onAirTimeStyles": "onAirItem-module-scss-module__YVbyfa__onAirTimeStyles",
  "showNameStyles": "onAirItem-module-scss-module__YVbyfa__showNameStyles",
});
